module.exports = __webpack_public_path__ + "src/assets/img/no-data.c824ac.png";